import React from "react";
import Layout from "../shared/Layout";
import { Container } from "shared/ui";
import Questions from "../Questions";

const QuestionsPage = () => {
  return (
    <Layout>
      <Container>
        <Questions />
      </Container>
    </Layout>
  );
};

export default QuestionsPage;
